__turbopack_context__.v({
  "above": "LCatalogLanding-module__bkPi9G__above",
  "below": "LCatalogLanding-module__bkPi9G__below",
  "content": "LCatalogLanding-module__bkPi9G__content",
  "root": "LCatalogLanding-module__bkPi9G__root",
});
